// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Constants.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
export default class DocumentStatus {
    public static readonly RUNNING: number = 1;
    public static readonly COMPLETE: number = 2;
    public static readonly ERROR: number = 3;
}
